export enum TransactionResponseStatus {
    AGUARDANDO_AUTORIZACAO = 'AGUARDANDO_AUTORIZACAO',
    AUTORIZADA_AGUARDANDO_EFETIVACAO = 'AUTORIZADA_AGUARDANDO_EFETIVACAO',
    TRANSFERENCIA_REALIZADA = 'TRANSFERENCIA_REALIZADA',
    AGUARDANDO_CONFIRMACAO_IF_DESTINO = 'AGUARDANDO_CONFIRMACAO_IF_DESTINO',
    TRANSFERENCIA_REPROVADA = 'TRANSFERENCIA_REPROVADA',
    TRANSFERENCIA_EXPIRADA = 'TRANSFERENCIA_EXPIRADA',
    ERRO_TRANSFERENCIA = 'ERRO_TRANSFERENCIA',
    REJEITADA_IF_DESTINO = 'REJEITADA_IF_DESTINO',
    CANCELADA_TESOURARIA = 'CANCELADA_TESOURARIA',
    CANCELADA_CLIENTE = 'CANCELADA_CLIENTE',
    AGUARDANDO_ANALISE_ANTIFRAUDE = 'AGUARDANDO_ANALISE_ANTIFRAUDE',
    CANCELADA_SUSPEITA_FRAUDE = 'CANCELADA_SUSPEITA_FRAUDE'
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transfers-other-banks/transfer-response/models/transaction-response-status.enum.ts